import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import CurrencyCell from "../../table/CurrencyCell";
import styles from "../../table/tableStyles";
import "./Theme3Table.scss";

const PrivateSectorPricesByMethodTable = ({ na, classes }) => (
  <div className={classes.container}>
    <table className={classNames("Theme3Table", classes.table)}>
      <thead>
        <tr className={classes.title}>
          <th className={classes.groupEnd} />
          <th
            colSpan={4}
            className={classNames(classes.center, classes.groupEnd)}
          >
            Private Subsidized
          </th>
          <th colSpan={4} className={classes.center}>
            Private Non-Subsidized
          </th>
        </tr>
        <tr className={classes.heading}>
          <th className={classes.groupEnd} />
          <th className={classes.center}>Implant</th>
          <th className={classes.center}>IUD</th>
          <th className={classes.center}>Injection</th>
          <th className={classNames(classes.center, classes.groupEnd)}>Pill</th>
          <th className={classes.center}>Implant</th>
          <th className={classes.center}>IUD</th>
          <th className={classes.center}>Injection</th>
          <th className={classes.center}>Pill</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={classes.groupEnd}>Asia</td>
          <CurrencyCell>0.87</CurrencyCell>
          <CurrencyCell>0.31</CurrencyCell>
          <CurrencyCell>0.43</CurrencyCell>
          <CurrencyCell className={classes.groupEnd}>0.07</CurrencyCell>
          <CurrencyCell>44.24</CurrencyCell>
          <CurrencyCell>7.75</CurrencyCell>
          <CurrencyCell>1.40</CurrencyCell>
          <CurrencyCell>3.11</CurrencyCell>
        </tr>
        <tr className={classes.row}>
          <td className={classes.groupEnd}>Europe</td>
          <td
            dangerouslySetInnerHTML={{
              __html: na
            }}
            className={classes.center}
          />
          <td
            dangerouslySetInnerHTML={{
              __html: na
            }}
            className={classes.center}
          />
          <td
            dangerouslySetInnerHTML={{
              __html: na
            }}
            className={classes.center}
          />
          <td
            dangerouslySetInnerHTML={{
              __html: na
            }}
            className={classNames(classes.center, classes.groupEnd)}
          />
          <CurrencyCell>181.72</CurrencyCell>
          <CurrencyCell>5.00</CurrencyCell>
          <CurrencyCell>1.92</CurrencyCell>
          <CurrencyCell>7.06</CurrencyCell>
        </tr>
        <tr className={classes.row}>
          <td className={classes.groupEnd}>Africa</td>
          <CurrencyCell>4.17</CurrencyCell>
          <CurrencyCell>0.44</CurrencyCell>
          <CurrencyCell>0.70</CurrencyCell>
          <CurrencyCell className={classes.groupEnd}>0.15</CurrencyCell>
          <CurrencyCell>14.60</CurrencyCell>
          <CurrencyCell>7.57</CurrencyCell>
          <CurrencyCell>1.09</CurrencyCell>
          <CurrencyCell>0.66</CurrencyCell>
        </tr>
        <tr className={classes.row}>
          <td className={classes.groupEnd}>Americas</td>
          <CurrencyCell>0.62</CurrencyCell>
          <td
            dangerouslySetInnerHTML={{
              __html: na
            }}
            className={classes.center}
          />
          <CurrencyCell>0.49</CurrencyCell>
          <td
            dangerouslySetInnerHTML={{
              __html: na
            }}
            className={classNames(classes.center, classes.groupEnd)}
          />
          <CurrencyCell>29.34</CurrencyCell>
          <CurrencyCell>21.83</CurrencyCell>
          <CurrencyCell>4.37</CurrencyCell>
          <CurrencyCell>5.31</CurrencyCell>
        </tr>
        <tr className={classes.totalRow}>
          <td className={classes.groupEnd}>Total</td>
          <CurrencyCell>3.68</CurrencyCell>
          <CurrencyCell>0.37</CurrencyCell>
          <CurrencyCell>0.68</CurrencyCell>
          <CurrencyCell className={classes.groupEnd}>0.13</CurrencyCell>
          <CurrencyCell>31.09</CurrencyCell>
          <CurrencyCell>12.55</CurrencyCell>
          <CurrencyCell>2.22</CurrencyCell>
          <CurrencyCell>3.14</CurrencyCell>
        </tr>
      </tbody>
    </table>
  </div>
);

PrivateSectorPricesByMethodTable.propTypes = {
  na: PropTypes.string
};

PrivateSectorPricesByMethodTable.defaultProps = {
  na: "n/a"
};

export default memo(withStyles(styles)(PrivateSectorPricesByMethodTable));
